import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Home from '../containers/Home';
import Login from '../containers/auth/Login';
import ForgotPassword from '../containers/auth/ForgotPassword';
import ResetPassword from '../containers/auth/ResetPassword';
import Signup from '../containers/auth/Signup';
import InternalLogin from '../containers/auth/InternalLogin';
import LoginCallback from '../containers/auth/LoginCallback';
import Logout from '../containers/auth/Logout';

const AppRouting = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgotPassword" element={<ForgotPassword />} />
      <Route path="/resetPassword" element={<ResetPassword activate />} />
      <Route path="/internallogin" element={<InternalLogin />} />
      <Route path="/loginCallback" element={<LoginCallback />} />
      <Route path="/logout" element={<Logout />} />
    </Routes>
  );
};

export default AppRouting;
